// ============================================================================
// useFilaContador · número de pedidos abertos ao lado de "Pré-agendamentos"
// ============================================================================
// 17/10/2026 (etapa E1 do desenho "Atendimento por IA + CRM"): contador no
// menu. Lê /api/atendimento-fila?op=contagem (só números, nada do cliente; o
// escopo por unidade é do SERVIDOR) a cada 60 s com a aba visível e ao voltar
// para a aba. Falha = mantém o último número (nunca zera calado).
// Uso: useFilaContador({ enabled: podeFila }) → { badge, total, alta }
// Correção 17/10/2026: AINDA SEM USO. O Sidebar.jsx fica intocado enquanto a
// obra do financeiro estiver aberta nele (desenho 3.10); ligar depois, só
// com IA_PEDIDOS diferente de off.
// 26/10/2026 (decisão do dono): LIGADO ao lado do "CRM da Sofia" (a aba
// Pré-agendamentos saiu do menu). O número é o `acao` do servidor (o que
// espera a recepção nos últimos 7 dias); sem ele (servidor antigo), o total
// de abertos de antes.
// ============================================================================

import { useEffect, useRef, useState } from 'react';
import { filaApi } from './atendimentoApi.js';

const POLL_MS = 60000;

export function useFilaContador({ enabled = false } = {}) {
  const [estado, setEstado] = useState({ total: null, alta: 0 });
  const vivo = useRef(true);

  useEffect(() => {
    vivo.current = true;
    if (!enabled) { setEstado({ total: null, alta: 0 }); return () => { vivo.current = false; }; }
    let emVoo = false;
    const buscar = async () => {
      if (emVoo || (typeof document !== 'undefined' && document.visibilityState === 'hidden')) return;
      emVoo = true;
      try {
        const r = await filaApi.contagem();
        const total = Number.isFinite(Number(r?.acao)) ? Number(r.acao) : Number(r?.abertos?.total);
        if (vivo.current && Number.isFinite(total)) setEstado({ total, alta: Number(r?.alta) || 0 });
      } catch { /* mantém o último número */ } finally { emVoo = false; }
    };
    buscar();
    const t = setInterval(buscar, POLL_MS);
    const temDoc = typeof document !== 'undefined';
    const onVisivel = () => { if (document.visibilityState === 'visible') buscar(); };
    if (temDoc) document.addEventListener('visibilitychange', onVisivel);
    return () => { vivo.current = false; clearInterval(t); if (temDoc) document.removeEventListener('visibilitychange', onVisivel); };
  }, [enabled]);

  return { badge: estado.total || undefined, total: estado.total, alta: estado.alta };
}

export default useFilaContador;
